import { Box } from '@mui/material';
import { useAtomValue } from 'jotai';
import { loadable } from 'jotai/utils';
import * as React from 'react';
import {
  BrowserRouter,
  Route,
  type RouteComponentProps,
  Switch
} from 'react-router-dom';
import { currentAuthAtom } from '../jotai/atoms';
import { analytics } from '../utils/analytics';
import { ConfirmManager } from './ConfirmManager';
import { Dashboard } from './Dashboard';
import { Header } from './Header';
import { Landing } from './Landing';
import { LoadingPage } from './LoadingPage';
import { NoticeManager } from './NoticeManager';
import { Register } from './Register';
import { SessionManager } from './SessionManager';
import { TeamSelect } from './TeamSelect';

const styles = {
  root: {
    height: '100vh',
    width: '100vw',
    overflow: 'scroll',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'start',
    alignItems: 'stretch'
  }
} as const;

const currentAuthLoadableAtom = loadable(currentAuthAtom);

export function Router({}) {
  // ログインしているかどうかで根っこのルーティングを切り替える
  const userInfoLoadable = useAtomValue(currentAuthLoadableAtom);

  return (
    <React.Suspense fallback={<LoadingPage />}>
      <BrowserRouter>
        <ConfirmManager />
        <NoticeManager />
        <SessionManager />
        <Route component={TrackingManager} />
        <Box sx={styles.root}>
          {userInfoLoadable.state === 'hasData' && userInfoLoadable.data ? (
            <SignedInRoot />
          ) : (
            <Landing />
          )}
        </Box>
      </BrowserRouter>
    </React.Suspense>
  );
}

function SignedInRoot({}) {
  return (
    <>
      <Route path="/" component={Header} />
      <Route exact path="/" component={TeamSelect} />
      <Switch>
        <Route path="/register" component={Register} />
        <Route path="/:teamId/:tab?" component={Dashboard} />
      </Switch>
    </>
  );
}

function TrackingManager(props: RouteComponentProps) {
  React.useEffect(() => {
    analytics.pageView(props.location.pathname);
  }, [props.location.pathname]);
  return null;
}
